import { useMutation } from "@tanstack/react-query";
import { message as antdMessage } from "antd";
import { recordAppDownload } from "../services/downloadService";

export const useRecordAppDownload = () => {
  return useMutation({
    mutationFn: recordAppDownload,
    onSuccess: () => {
      antdMessage.success("App install recorded");
    },
    onError: () => {
      antdMessage.error("Failed to record app install");
    },
  });
};